import { EcommerceService } from 'services'

class PostsService extends EcommerceService {
  getAllPosts() {
    const self = this
    const url = `/blog`
    const req = self.setUrl(url).get()
    return req
  }
}

export default PostsService
